import { VideoExtensions, ManifestExtensions, } from '../Utils/Constants';
export default class Utils {
    static getRouteAndFilename(stringUrl) {
        const url = new URL(stringUrl);
        const route = url.origin + url.pathname;
        const limit = route.lastIndexOf('/') + 1;
        return {
            route: route.slice(0, limit),
            fileName: route.slice(limit)
        };
    }
    static getPath(stringUrl) {
        const url = new URL(stringUrl);
        const path = url.pathname;
        return {
            path: path
        };
    }
    static delay(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
    }
    static findPathMach(url, path, newCdn) {
        // Logger.log("New base path 0 -> "+url);
        // Logger.log("New base path 1 -> "+newCdn.url);
        // Logger.log("New base path 2 -> "+path);
        // Logger.log("New base path 3 -> "+newCdn.host);
        let updatedPath = newCdn.url;
        let originalUrl = url;
        url = url.split("?")[0];
        let current = new URL(url);
        let resource = new URL(path);
        if (current.host != resource.host) {
            current.host = resource.host;
            url = current.toString();
        }
        let value = path;
        let i = 4;
        if (path != undefined && path != '') {
            while (!url.includes(value)) {
                if (!value.includes('/'))
                    break;
                if (value.endsWith('/')) {
                    value = value.substr(0, value.length - 1);
                }
                let toDelete = value.substr(value.lastIndexOf('/'), value.length);
                //Logger.log("New base path 4.1x-> "+toDelete+" | "+updatedPath);
                if (updatedPath.endsWith(toDelete) || updatedPath.endsWith(toDelete + "/")) {
                    if (updatedPath.endsWith('/')) {
                        updatedPath = updatedPath.substr(0, updatedPath.length - 1);
                    }
                    updatedPath = updatedPath.substr(0, updatedPath.lastIndexOf('/') + 1);
                    //    Logger.log("New base path "+i+".delete -> "+updatedPath);
                }
                value = value.substr(0, value.lastIndexOf('/') + 1);
                //    Logger.log("New base path "+i+" -> "+value);
                if (value == 'https://' || value == 'http://') {
                    return '';
                }
            }
            i++;
        }
        let updatedUrl = url.replace(value, updatedPath);
        //Logger.log("New base path 5 -> "+updatedUrl);
        return updatedUrl;
    }
    static isMedia(path) {
        let isMedia = false;
        VideoExtensions.forEach((ext) => {
            isMedia = isMedia || path.endsWith(ext);
        });
        return isMedia;
    }
    static isManifest(path) {
        let isManifest = false;
        ManifestExtensions.forEach((ext) => {
            isManifest = isManifest || path.endsWith(ext);
        });
        return isManifest;
    }
    static bufferToString(b) {
        //eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return String.fromCharCode.apply(null, new Uint8Array(b));
    }
    static returnRandom(a) {
        let ret = '';
        const len = a.length - 1;
        if (len > 0) {
            const position = Math.round(Math.random() * len);
            ret = a[position];
        }
        return ret;
    }
    static formatParameters(params) {
        return "?" + Object
            .keys(params)
            .map(function (key) {
            return key + "=" + encodeURIComponent(params[key]);
        })
            .join("&");
    }
    static ifByteArrayToString(data) {
        if ((typeof data) != 'string') {
            //eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            return String.fromCharCode.apply(null, new Uint8Array(data));
        }
        return data;
    }
}
